import { Injectable, inject } from '@angular/core';
import { Meta, Title } from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class MetaTagService {
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);

  updateTitle(title: string) {
    this.title.setTitle(title);
  }

  updateDescription(desc: string) {
    this.meta.updateTag({ name: 'description', content: desc });
    this.meta.updateTag({ name: 'og:description', content: desc });
  }

  updateVideoSocialInfo(videoUrl: string, title: string, desc: string, previewUrl?: string) {
    this.updateTitle(title);
    this.updateDescription(desc);
    this.meta.updateTag({ name: 'og:type', content: 'video' });
    this.meta.updateTag({ name: 'og:title', content: title });
    this.meta.updateTag({ name: 'og:description', content: desc });
    this.meta.updateTag({ name: 'og:video', content: videoUrl });
    if (previewUrl) {
      this.meta.updateTag({ name: 'og:image', content: previewUrl });
    }
  }

  updateMediaInfo(title: string, desc: string, imageUrl?: string) {
    this.updateTitle(title);
    this.updateDescription(desc);
    //this.meta.updateTag({ name: 'og:type', content: 'profile' });
    this.meta.updateTag({ name: 'og:title', content: title });
    this.meta.updateTag({ name: 'og:description', content: desc });
    if (imageUrl) {
      this.meta.updateTag({ name: 'og:image', content: imageUrl });
    }
  }

  updateKeywords(key: string) {
    this.meta.updateTag({ name: 'keywords', content: key });
  }
}
